import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_HORARIOS,
  ALL_HORARIOS,
  LOADING_ALL_HORARIOS,
  ALL_DOCENTES_HORARIOS,
  SETTINGS_HORARIOS,
} from './HorariosReducer';
import {
  deleteHorariosService,
  allDocentesHorariosService,
  allHorariosService,
  oneHorariosService,
  saveHorariosService,
  updatedCalendarHorariosService,
} from './HorariosService';

export const allHorariosAction = async (
  { dispatch, horariosStore },
  params,
  isAll,
) => {
  if (horariosStore) {
    dispatch({
      type: SETTINGS_HORARIOS,
      payload: {
        ...horariosStore.settings,
        isAll,
      },
    });
  }
  try {
    dispatch({ type: LOADING_ALL_HORARIOS, payload: true });
    const res = await allHorariosService(params);
    dispatch({ type: ALL_HORARIOS, payload: res.data });
    dispatch({ type: LOADING_ALL_HORARIOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_HORARIOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveHorariosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveHorariosService(id, data);
    notify(res.data.message);
    await allHorariosAction({ dispatch }, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const updatedCalendarHorariosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await updatedCalendarHorariosService(id, data);
    notify(res.data.message);
    await allHorariosAction({ dispatch }, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoHorariosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_HORARIOS, payload: data });
};

export const oneHorariosAction = async (dispatch, id) => {
  try {
    const res = await oneHorariosService(id);
    await setActivoHorariosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteHorariosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteHorariosService(id);
    notify(res.data.message);
    await setActivoHorariosAction(dispatch, null);
    await allHorariosAction({ dispatch }, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const allDocentesHorariosAction = async (dispatch, params) => {
  try {
    const res = await allDocentesHorariosService(params);
    dispatch({ type: ALL_DOCENTES_HORARIOS, payload: res.data });
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
